import { render } from "./dataMonitor.vue?vue&type=template&id=a98a8afa&scoped=true"
import script from "./dataMonitor.vue?vue&type=script&lang=js"
export * from "./dataMonitor.vue?vue&type=script&lang=js"

import "./dataMonitor.vue?vue&type=style&index=0&id=a98a8afa&lang=scss&scoped=scoped"
import "./dataMonitor.vue?vue&type=style&index=1&id=a98a8afa&scoped=true&lang=css"

import exportComponent from "/Users/cw/Desktop/BME/screen_project_315/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a98a8afa"]])

export default __exports__